export default __webpack_public_path__ + "static/media/printIconWhite.0c38985d.svg";